import React from 'react';
import { FaBrain } from 'react-icons/fa';

const BasketStats = ({ topics }) => {
  if (!topics || topics.length === 0) return null;

  const totalTopics = topics.length;
  const masteredTopics = topics.filter(topic => topic.is_master).length;
  const masteryPercentage = Math.round((masteredTopics / totalTopics) * 100);

  return (
    <div className="flex items-center gap-2 py-1">
      <div className="flex items-center gap-1.5">
        <FaBrain className="w-3.5 h-3.5 text-butter-500" />
        <span className="text-sm font-medium text-neutral-600">
          {masteredTopics}/{totalTopics}
        </span>
      </div>
      <span className="text-xs text-neutral-500">
        ({masteryPercentage}% mastered)
      </span>
    </div>
  );
};

export default BasketStats; 